import React from 'react';
import { Box, Typography } from '@mui/joy';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'primary.500',
        color: '#fff',
        py: 0.875,
        px: 2,
        textAlign: 'center',
        mt: 'auto',
        flexShrink: 0,
        position: 'relative',
        zIndex: 2
      }}
    >
      <Typography level="body-sm" sx={{ color: 'inherit', lineHeight: 1.2 }}>
        Copyright © {year}. All Rights Reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
